import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useAuthStore } from "@/store";
import { Toaster } from "@/components/ui/sonner";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import ReportEditorPage from "@/pages/ReportEditorPage";
import ConsolidatedReportPage from "@/pages/ConsolidatedReportPage";
import TemplateEditorPage from "@/pages/TemplateEditorPage";
import TemplateManagerPage from "@/pages/TemplateManagerPage";
import AdminPage from "@/pages/AdminPage";
import PeriodsPage from "@/pages/PeriodsPage";
import UnitSettingsPage from "@/pages/UnitSettingsPage";
import InstructionsPage from "@/pages/InstructionsPage";
import { AppLayout } from "@/components/AppLayout";

function RequireAuth({ children }) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App min-h-screen bg-background">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<RequireAuth><AppLayout /></RequireAuth>}>
            <Route index element={<DashboardPage />} />
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="templates" element={<TemplateManagerPage />} />
            <Route path="periods" element={<PeriodsPage />} />
            <Route path="admin" element={<AdminPage />} />
            <Route path="unit-settings" element={<UnitSettingsPage />} />
            <Route path="instructions" element={<InstructionsPage />} />
          </Route>
          <Route path="/report/:instanceId" element={
            <RequireAuth><ReportEditorPage /></RequireAuth>
          } />
          <Route path="/consolidated/:periodId" element={
            <RequireAuth><ConsolidatedReportPage /></RequireAuth>
          } />
          <Route path="/template-editor/:templateId" element={
            <RequireAuth><TemplateEditorPage /></RequireAuth>
          } />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
